import MarkerClusterer from '@googlemaps/markerclustererplus'
import _ from 'lodash'

let bounds = null

let markers = []

let lastMarker = null

let availableSellingPoints = []

let markerCluster = null

let infowindow = null

let map = null

function initMap () {
  bounds = new window.google.maps.LatLngBounds()
  const sellingPointsForBounds = window.sellling_points
  $.each(sellingPointsForBounds, function (k, v) {
    bounds.extend({ lng: v.longitude * 1.0, lat: v.latitude * 1.0 })
  })
  map = new window.google.maps.Map(document.getElementById('map'), {
    center: bounds.getCenter()
  })
  map.fitBounds(bounds)
  infowindow = new window.google.maps.InfoWindow()
  updateMap()
  window.map = map
}

function setMapAll (map) {
  $.each(markers, function (k, v) {
    v.setMap(map)
  })
}

function updateMap () {
  setMapAll(null)
  markers = []
  bounds = new window.google.maps.LatLngBounds()
  const sellingPointsForBound = (!_.isEmpty(availableSellingPoints)) ? availableSellingPoints : window.selling_points
  $.each(sellingPointsForBound, function (k, v) {
    bounds.extend({ lng: v.longitude * 1.0, lat: v.latitude * 1.0 })
  })
  map = new window.google.maps.Map(document.getElementById('map'), {
    center: bounds.getCenter()
  })
  map.fitBounds(bounds)
  $.each(availableSellingPoints, function (k, v) {
    const infoStr = `<div id="content">
          <div id="siteNotice">
              <h5>${v.name}</h5>
              <ul>
                  <li><b>Διεύθυνση:</b> ${v.address}</li>
                  <li><b>Τ.Κ.:</b> ${v.postal}</li>
                  <li><b>Τηλέφωνο:</b> ${v.phone}</li>
              </ul>
          </div>
      </div>`
    const marker = new window.google.maps.Marker({
      position: { lat: v.latitude * 1.0, lng: v.longitude * 1.0 },
      title: v.name
    })
    marker.addListener('click', () => {
      infowindow.setContent(infoStr)
      infowindow.open(map, marker)

      if (lastMarker !== null && lastMarker.getAnimation() !== null) {
        lastMarker.setAnimation(null)
      }

      marker.setAnimation(window.google.maps.Animation.BOUNCE)
      lastMarker = marker
    })

    infowindow.addListener('closeclick', function () {
      lastMarker.setAnimation(null)
    })
    markers.push(marker)

    markerCluster = new MarkerClusterer(map, markers, {
      imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
    })
  })
}

function findClosest (input) {
  const searchPlaceService = new google.maps.places.PlacesService(window.map)
  searchPlaceService.textSearch({
    location: new google.maps.LatLng({ lat: 37.744319, lng: 27.891633 }),
    radius: '1000km',
    query: input
  }, function (results, status) {
    if (status !== google.maps.places.PlacesServiceStatus.OK) { return }
    window.Vue.$emit('findClosest', sortSellingPointsByClosest(_.first(results).geometry.location))
  })
}

function sortSellingPointsByClosest (from) {
  const distances = []
  if (_.isEmpty(availableSellingPoints)) { availableSellingPoints = window.selling_points }
  for (const [i, sellingPoint] of Object.entries(availableSellingPoints)) {
    const to = new google.maps.LatLng({
      lat: sellingPoint.latitude * 1.0,
      lng: sellingPoint.longitude * 1.0
    })
    distances.push({
      sellingPoint: sellingPoint,
      distance: google.maps.geometry.spherical.computeDistanceBetween(from, to)
    })
  }
  return _.orderBy(distances, ['distance'], ['asc'])
}

const GoogleMapsService = {
  /**
   * gets the map client
   * @returns {any}
   * @param sellingPoints
   */
  createMap: (sellingPoints) => {
    availableSellingPoints = sellingPoints
    window.initMap = initMap
    window.findClosest = findClosest
  },
  updateMap: (sellingPoints) => {
    availableSellingPoints = sellingPoints
    try {
      updateMap()
    } catch (ignored) {}
  },
  findClosest: (input, sellingPoints) => {
    availableSellingPoints = sellingPoints
    window.findClosest(input)
  }
}

export default GoogleMapsService
